<template>
  <div>
    <AccordionCard :state="cards.photoOfWallboxAttachments">
      <template v-slot:header>
        {{ $t('photoOfWallboxAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('photoOfWallboxAttachments') }}</div>
        <div class="flex-column select"></div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.photoOfWallboxAttachments"
            attachmentType="photoOfWallboxAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isphotoOfWallboxAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="photoOfWallboxAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isphotoOfWallboxAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.accessCardsOfWallboxAttachments">
      <template v-slot:header>
        {{ $t('accessCardsOfWallboxAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('accessCardsOfWallboxAttachments') }}</div>
        <div class="flex-column select"></div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.accessCardsOfWallboxAttachments"
            attachmentType="accessCardsOfWallboxAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isaccessCardsOfWallboxAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="accessCardsOfWallboxAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isaccessCardsOfWallboxAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.circuitBreakerAndSafetySwitchForWallboxAttachments">
      <template v-slot:header>
        {{ $t('circuitBreakerAndSafetySwitchForWallboxAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('circuitBreakerAndSafetySwitchForWallboxAttachments') }}
        </div>
        <div class="flex-column select"></div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.circuitBreakerAndSafetySwitchForWallboxAttachments"
            attachmentType="circuitBreakerAndSafetySwitchForWallboxAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="iscircuitBreakerAndSafetySwitchForWallboxAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="circuitBreakerAndSafetySwitchForWallboxAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="
              iscircuitBreakerAndSafetySwitchForWallboxAttachmentsUploadComplete = false
            "
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.cablingBetweenWallboxAndDistributionAttachments">
      <template v-slot:header>
        {{ $t('cablingBetweenWallboxAndDistributionAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('cablingBetweenWallboxAndDistributionAttachments') }}
        </div>
        <div class="flex-column select"></div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.cablingBetweenWallboxAndDistributionAttachments"
            attachmentType="cablingBetweenWallboxAndDistributionAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="iscablingBetweenWallboxAndDistributionAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="cablingBetweenWallboxAndDistributionAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="
              iscablingBetweenWallboxAndDistributionAttachmentsUploadComplete = false
            "
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import AccordionCard from '@/components/AccordionCard';
import AccordionCardOptionalInput from '@/components/AccordionCardOptionalInput';
import AttachmentGallery from '@/components/AttachmentGallery';
import DropzoneUpload from '@/components/DropzoneUpload';

export default {
  name: 'ExistingDamage',
  components: {
    AccordionCard,
    AttachmentGallery,
    DropzoneUpload,
    //AccordionCardOptionalInput,
  },
  mixins: [AccessBlockMixin],
  props: {
    project: { type: Object },
    cards: { type: Object },
    /**
     * Template images from `MobileProjectsReport` (block field, or the store getter outside the
     * block).
     */
    referenceData: { type: Object, default: () => ({ reportTemplateImages: [] }) },
  },
  data() {
    return {
      /** track Upload states for clearing dropzone preview */
      isphotoOfWallboxAttachmentsUploadComplete: false,
      isaccessCardsOfWallboxAttachmentsUploadComplete: false,
      iscircuitBreakerAndSafetySwitchForWallboxAttachmentsUploadComplete: false,
      iscablingBetweenWallboxAndDistributionAttachmentsUploadComplete: false,
    };
  },
  computed: {
    ...mapGetters(['getEnumValues']),
    ...mapGetters('auth', ['isOrganizationRoleNavigationEnabled']),
  },

  methods: {
    ...mapActions(['uploadProjectAttachment', 'deleteProjectAttachment']),

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },

    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
    },
  },
  async mounted() {
    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.isphotoOfWallboxAttachmentsUploadComplete = true;
          this.isaccessCardsOfWallboxAttachmentsUploadComplete = true;
          this.iscircuitBreakerAndSafetySwitchForWallboxAttachmentsUploadComplete = true;
          this.iscablingBetweenWallboxAndDistributionAttachmentsUploadComplete = true;
        }
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>
